export const API_BASE = process.env.REACT_APP_API_BASE;
export const OAUTH_URL = process.env.REACT_APP_OAUTH_URL;
